// BotanicalCollector Shopify Theme — Interactions
// Shared modal scroll lock: keep the page fixed and let only the top panel scroll.
var pageScrollLocks = [];
var pageScrollSnapshot = null;
var pageScrollTouch = null;

function getPageScrollY() {
  return pageScrollSnapshot ? pageScrollSnapshot.y : window.scrollY;
}

function preventPageLockedScroll(event) {
  if (event.cancelable) event.preventDefault();
}

function onPageLockedTouchStart(event) {
  pageScrollTouch = event.touches.length === 1
    ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
    : null;
}

function onPageLockedTouchMove(event) {
  if (!pageScrollLocks.length) return;
  // A zoomed visual viewport must be free to pan; the fixed body still locks page scroll.
  if (window.visualViewport && window.visualViewport.scale > 1.01) {
    pageScrollTouch = null;
    return;
  }
  // Keep pinch zoom available, including zooming back out after opening a panel.
  if (event.touches.length !== 1) {
    pageScrollTouch = null;
    return;
  }
  var touch = event.touches[0];
  if (!pageScrollTouch) {
    pageScrollTouch = { x: touch.clientX, y: touch.clientY };
    return;
  }
  var dx = touch.clientX - pageScrollTouch.x;
  var dy = touch.clientY - pageScrollTouch.y;
  pageScrollTouch = { x: touch.clientX, y: touch.clientY };
  var panel = pageScrollLocks[pageScrollLocks.length - 1].panel;
  var node = event.target.nodeType === 1 ? event.target : event.target.parentElement;
  var horizontal = Math.abs(dx) > Math.abs(dy);
  var delta = horizontal ? dx : dy;
  // Prevent scrolling on the mask and at a panel's scroll boundaries (iOS Safari).
  while (node && panel && panel.contains(node)) {
    var style = window.getComputedStyle(node);
    var overflow = horizontal ? style.overflowX : style.overflowY;
    var limit = horizontal ? node.scrollWidth - node.clientWidth : node.scrollHeight - node.clientHeight;
    var position = horizontal ? node.scrollLeft : node.scrollTop;
    if (/auto|scroll/.test(overflow) && limit > 1 &&
        ((delta > 0 && position > 0) || (delta < 0 && position < limit - 1))) return;
    if (node === panel) break;
    node = node.parentElement;
  }
  preventPageLockedScroll(event);
}

function lockPageScroll(owner, panel) {
  if (!owner || pageScrollLocks.some(function(lock) { return lock.owner === owner; })) return;
  pageScrollLocks.push({ owner: owner, panel: panel || owner });
  if (pageScrollSnapshot) return;
  var body = document.body;
  pageScrollSnapshot = { x: window.scrollX, y: window.scrollY, styles: {} };
  ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach(function(property) {
    pageScrollSnapshot.styles[property] = {
      value: body.style.getPropertyValue(property),
      priority: body.style.getPropertyPriority(property)
    };
  });
  body.style.position = 'fixed';
  body.style.top = '-' + pageScrollSnapshot.y + 'px';
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
  document.documentElement.classList.add('is-page-scroll-locked');
  document.addEventListener('touchstart', onPageLockedTouchStart, { passive: true, capture: true });
  document.addEventListener('touchend', onPageLockedTouchStart, { passive: true, capture: true });
  document.addEventListener('touchmove', onPageLockedTouchMove, { passive: false, capture: true });
}

function unlockPageScroll(owner) {
  pageScrollLocks = pageScrollLocks.filter(function(lock) { return lock.owner !== owner; });
  if (pageScrollLocks.length || !pageScrollSnapshot) return;
  var saved = pageScrollSnapshot;
  pageScrollSnapshot = null;
  pageScrollTouch = null;
  var root = document.documentElement;
  var behavior = root.style.getPropertyValue('scroll-behavior');
  var priority = root.style.getPropertyPriority('scroll-behavior');
  // Restore the saved position immediately, without the site's smooth-scroll animation.
  root.style.setProperty('scroll-behavior', 'auto', 'important');
  Object.keys(saved.styles).forEach(function(property) {
    var style = saved.styles[property];
    if (style.value) document.body.style.setProperty(property, style.value, style.priority);
    else document.body.style.removeProperty(property);
  });
  root.classList.remove('is-page-scroll-locked');
  window.scrollTo(saved.x, saved.y);
  if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
  else root.style.removeProperty('scroll-behavior');
  document.removeEventListener('touchstart', onPageLockedTouchStart, true);
  document.removeEventListener('touchend', onPageLockedTouchStart, true);
  document.removeEventListener('touchmove', onPageLockedTouchMove, true);
}

document.addEventListener('shopify:section:unload', function(event) {
  pageScrollLocks.slice().forEach(function(lock) {
    if (event.target.contains(lock.owner)) unlockPageScroll(lock.owner);
  });
});

document.addEventListener('DOMContentLoaded', function() {

  // === Header scroll effect ===
  var header = document.getElementById('siteHeader');
  var isHome = document.body.classList.contains('template-index');

  function onScroll() {
    var scrolled = getPageScrollY() > 30;
    if (header) {
      header.classList.toggle('scrolled', scrolled || !isHome);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // === 404: path-based messaging (product / article / etc.) ===
  init404Page();

  // === Image protection: disable right-click save & drag ===
  function isSiteImage(el) {
    return el && el.tagName === 'IMG';
  }

  document.addEventListener('contextmenu', function(e) {
    if (isSiteImage(e.target)) e.preventDefault();
  });

  document.addEventListener('dragstart', function(e) {
    if (isSiteImage(e.target)) e.preventDefault();
  }, true);

  // === Mobile menu overlay click ===
  var overlay = document.getElementById('mobileOverlay');
  if (overlay) {
    overlay.addEventListener('click', closeMobileMenu);
  }

  // === Reveal animation (IntersectionObserver) ===
  // First 1.3 viewports show immediately so mobile PDP titles are not left invisible.
  // Fade-up only applies to content further down the page.
  if ('IntersectionObserver' in window) {
    var REVEAL_INSTANT_VIEWPORTS = 1.3;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    function observeReveal() {
      var instantBottom = window.innerHeight * REVEAL_INSTANT_VIEWPORTS;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function(el) {
        if (reduceMotion || el.getBoundingClientRect().top < instantBottom) {
          el.classList.add('is-visible', 'is-reveal-instant');
          return;
        }
        observer.observe(el);
      });
    }

    observeReveal();

    var revealRoot = document.getElementById('main') || document.body;
    var revealScanTimer = null;
    function scheduleRevealScan() {
      if (revealScanTimer) window.clearTimeout(revealScanTimer);
      revealScanTimer = window.setTimeout(observeReveal, 120);
    }

    if ('MutationObserver' in window && revealRoot) {
      var revealObserver = new MutationObserver(scheduleRevealScan);
      revealObserver.observe(revealRoot, { childList: true, subtree: true });
    } else {
      window.setTimeout(observeReveal, 400);
    }
  } else {
    document.querySelectorAll('.reveal').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  // === Sub-hero image carousel (Rare & Exotic Plants) ===
  document.querySelectorAll('[data-sub-hero-carousel]').forEach(function(root) {
    if (root.getAttribute('data-autoplay') === 'false') return;

    var slides = root.querySelectorAll('[data-sub-hero-slide]');
    if (slides.length < 2) return;

    var dots = root.querySelectorAll('[data-sub-hero-dot]');
    var interval = parseInt(root.getAttribute('data-interval') || '3000', 10);
    var index = 0;
    var timer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setActive(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function(dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function next() {
      setActive(index + 1);
    }

    function start() {
      if (reducedMotion) return;
      stop();
      timer = window.setInterval(next, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var target = parseInt(dot.getAttribute('data-index') || '0', 10);
        setActive(target);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
  });

  // === Rare plant showcase: three linked products per carousel page ===
  function pagedCarouselRoots(scope, selector) {
    var roots = [];
    if (scope && scope.matches && scope.matches(selector)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll(selector).forEach(function(root) { roots.push(root); });
    }
    return roots;
  }

  function initPagedFadeCarousel(root, pageSel, dotSel, initAttr) {
    if (root.getAttribute(initAttr) === 'true') return;
    root.setAttribute(initAttr, 'true');

    var pages = root.querySelectorAll(pageSel);
    if (!pages.length) return;

    root.classList.add('is-carousel-ready');
    if (pages.length < 2) return;

    var dots = root.querySelectorAll(dotSel);
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var index = 0;
    var timer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setActive(nextIndex) {
      index = (nextIndex + pages.length) % pages.length;
      pages.forEach(function(page, pageIndex) {
        var active = pageIndex === index;
        page.classList.toggle('is-active', active);
        page.setAttribute('aria-hidden', active ? 'false' : 'true');
        page.inert = !active;
      });
      dots.forEach(function(dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.setAttribute('tabindex', active ? '0' : '-1');
      });
    }

    function stop() {
      root.classList.add('is-progress-paused');
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function carouselIsHidden(node) {
      return window.getComputedStyle(node).display === 'none';
    }

    function start() {
      if (reducedMotion) return;
      if (carouselIsHidden(root)) return;
      stop();
      root.classList.remove('is-progress-paused');
      if ((root.hasAttribute('data-rare-showcase') || root.hasAttribute('data-home-seeds')) && dots[index]) {
        dots[index].classList.remove('is-active');
        void dots[index].offsetWidth;
        dots[index].classList.add('is-active');
      }
      timer = window.setInterval(function() { setActive(index + 1); }, interval);
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        setActive(parseInt(dot.getAttribute('data-index') || '0', 10));
        start();
      });
      dot.addEventListener('keydown', function(event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = index + 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = index - 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = dots.length - 1;
        else return;

        event.preventDefault();
        setActive(nextIndex);
        dots[index].focus();
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root.pagedCarouselDestroy = stop;
    root.pagedCarouselStart = start;
    start();
  }

  function initRareShowcase(scope) {
    pagedCarouselRoots(scope, '[data-rare-showcase]').forEach(function(root) {
      initPagedFadeCarousel(root, '[data-rare-showcase-page]', '[data-rare-showcase-dot]', 'data-rare-showcase-initialized');
    });
  }

  function initHomeSeeds(scope) {
    pagedCarouselRoots(scope, '[data-home-seeds]').forEach(function(root) {
      initPagedFadeCarousel(root, '[data-home-seeds-page]', '[data-home-seeds-dot]', 'data-home-seeds-initialized');
    });
  }

  function syncHomeSeedStages() {
    document.querySelectorAll('[data-home-seeds]').forEach(function(root) {
      var hidden = window.getComputedStyle(root).display === 'none';
      root.toggleAttribute('inert', hidden);
      if (hidden) {
        if (typeof root.pagedCarouselDestroy === 'function') root.pagedCarouselDestroy();
      } else if (typeof root.pagedCarouselStart === 'function') {
        root.pagedCarouselStart();
      }
    });
  }

  initRareShowcase(document);
  initHomeSeeds(document);
  syncHomeSeedStages();
  document.addEventListener('shopify:section:load', function(event) {
    initRareShowcase(event.target);
    initHomeSeeds(event.target);
    syncHomeSeedStages();
  });
  document.addEventListener('shopify:section:unload', function(event) {
    pagedCarouselRoots(event.target, '[data-rare-showcase], [data-home-seeds]').forEach(function(root) {
      if (typeof root.pagedCarouselDestroy === 'function') root.pagedCarouselDestroy();
    });
  });
  window.matchMedia('(max-width: 1120px)').addEventListener('change', syncHomeSeedStages);

  initProductCardVideos();
  initImageLightbox();
  initCustomerStoriesCarousel();
  initCartDrawer();
  initSeedsRail();
  initCartDiscounts();
  initCartMarketNotice();
  initScrollToTop();
  initSearchResultsView();
  initSearchPageAjax();
});

function initSearchPageAjax() {
  var page = document.querySelector('.search-page');
  if (!page) return;

  var form = page.querySelector('.search-form');
  var input = form && form.querySelector('input[name="q"]');
  var region = page.querySelector('[data-search-results-region]');
  var status = page.querySelector('[data-search-results-status]');
  if (!form || !input || !region) return;

  var controller = null;

  function setSearchMeta(attribute, key, content, removeWhenBlank) {
    var meta = document.head.querySelector('meta[' + attribute + '="' + key + '"]');
    if (removeWhenBlank && !content) {
      if (meta) meta.remove();
      return;
    }
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute(attribute, key);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  }

  function syncSearchSeo(template) {
    var data = template.dataset;
    var canonical = new URL(data.canonical, window.location.href);
    canonical.searchParams.delete('section_id');

    if (data.themeMetaEnabled === 'true') {
      document.title = data.title;
      setSearchMeta('name', 'description', data.description);
      setSearchMeta('name', 'robots', data.robots);
      var canonicalLink = document.head.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = canonical.href;
    }

    setSearchMeta('property', 'og:url', canonical.href);
    setSearchMeta('property', 'og:title', data.socialTitle);
    setSearchMeta('property', 'og:description', data.description, true);
    setSearchMeta('name', 'twitter:title', data.socialTitle);
    setSearchMeta('name', 'twitter:description', data.description, true);
  }

  function updateResults(url, options) {
    options = options || {};
    if (controller) controller.abort();
    controller = new AbortController();
    var request = controller;
    var target = new URL(url, window.location.href);
    target.searchParams.delete('section_id');
    input.value = target.searchParams.get('q') || '';
    var headerInput = document.querySelector('.header-search__input');
    if (headerInput) headerInput.value = input.value;

    var sectionUrl = new URL(target.href);
    sectionUrl.searchParams.set('section_id', 'search-results');
    region.setAttribute('aria-busy', 'true');
    region.classList.add('is-loading');
    if (status) status.textContent = 'Searching…';

    fetch(sectionUrl.href, { signal: request.signal, headers: { 'Accept': 'text/html' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.text();
      })
      .then(function(html) {
        if (request !== controller) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextSection = doc.getElementById('shopify-section-search-results');
        var currentSection = region.querySelector('#shopify-section-search-results');
        var nextSeo = nextSection && nextSection.querySelector('[data-search-seo]');
        if (!nextSection || !currentSection || !nextSeo) throw new Error('Search results missing');

        nextSection.querySelectorAll('.pagination a').forEach(function(link) {
          var pageUrl = new URL(link.href, target.href);
          pageUrl.searchParams.delete('section_id');
          if (!pageUrl.searchParams.has('q')) pageUrl.searchParams.set('q', target.searchParams.get('q') || '');
          link.href = pageUrl.pathname + pageUrl.search + pageUrl.hash;
        });

        currentSection.replaceWith(nextSection);
        initSearchResultsView();
        initProductCardVideos(nextSection);
        initImageLightbox();

        if (!options.popstate && target.href !== window.location.href) {
          window.history.pushState({}, '', target.pathname + target.search + target.hash);
        }
        syncSearchSeo(nextSeo);
        if (status) {
          var count = nextSection.querySelector('.search-results__count');
          status.textContent = count ? count.textContent.trim().replace(/\s+/g, ' ') : 'Search ready.';
        }
        if (options.pagination) {
          var header = document.getElementById('siteHeader');
          var offset = header ? header.offsetHeight : 0;
          var top = region.getBoundingClientRect().top + window.scrollY - offset - 16;
          window.scrollTo({ top: Math.max(top, 0), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      })
      .catch(function(error) {
        if (error.name !== 'AbortError' && request === controller) {
          window.location.assign(target.href);
        }
      })
      .finally(function() {
        if (request !== controller) return;
        region.setAttribute('aria-busy', 'false');
        region.classList.remove('is-loading');
        controller = null;
      });
  }

  form.addEventListener('submit', function(event) {
    event.preventDefault();
    var url = new URL(form.action, window.location.href);
    url.searchParams.set('q', input.value.trim());
    updateResults(url.href);
  });

  var headerForm = document.querySelector('.header-search__form');
  if (headerForm) {
    headerForm.addEventListener('submit', function(event) {
      event.preventDefault();
      var headerInput = headerForm.querySelector('input[name="q"]');
      var url = new URL(headerForm.action, window.location.href);
      url.searchParams.set('q', headerInput ? headerInput.value.trim() : '');
      if (typeof closeHeaderSearch === 'function') closeHeaderSearch();
      updateResults(url.href);
    });
  }

  var headerMore = document.getElementById('headerSearchSuggestMore');
  if (headerMore) {
    headerMore.addEventListener('click', function(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (typeof closeHeaderSearch === 'function') closeHeaderSearch();
      updateResults(headerMore.href);
    });
  }

  page.addEventListener('click', function(event) {
    var link = event.target.closest('.search-hero__tag, .search-page__results .pagination a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    event.preventDefault();
    updateResults(link.href, { pagination: !!link.closest('.pagination') });
  });

  window.addEventListener('popstate', function() {
    updateResults(window.location.href, { popstate: true });
  });
}

function initSearchResultsView() {
  var grid = document.querySelector('.search-results__grid');
  var buttons = document.querySelectorAll('[data-search-view]');
  if (!grid || !buttons.length) return;

  function setView(view) {
    var isList = view === 'list';
    grid.classList.toggle('is-list-view', isList);
    buttons.forEach(function(button) {
      var isActive = button.getAttribute('data-search-view') === view;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      setView(button.getAttribute('data-search-view') === 'list' ? 'list' : 'grid');
    });
  });

  setView('grid');
}

function initScrollToTop() {
  var button = document.querySelector('[data-scroll-to-top]');
  if (!button) return;

  var ticking = false;

  function updateScrollProgress() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var documentHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight
    );
    var maxScroll = Math.max(documentHeight - viewportHeight, 0);
    var progress = maxScroll > 0 ? Math.min(Math.max(scrollTop / maxScroll, 0), 1) : 0;
    var remaining = Math.max(Math.round((1 - progress) * 100), 0);
    var isVisible = maxScroll > 0 && scrollTop > viewportHeight * 1.3;

    button.style.setProperty('--scroll-progress', (progress * 360).toFixed(1) + 'deg');
    button.classList.toggle('is-visible', isVisible);
    button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    button.setAttribute('tabindex', isVisible ? '0' : '-1');
    button.setAttribute('aria-label', 'Scroll to top. ' + remaining + '% of the page remains below.');
    ticking = false;
  }

  function requestProgressUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScrollProgress);
  }

  button.addEventListener('click', function() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', requestProgressUpdate, { passive: true });
  window.addEventListener('resize', requestProgressUpdate);
  window.addEventListener('load', requestProgressUpdate);
  requestProgressUpdate();
}

function initCustomerStoriesCarousel() {
  document.querySelectorAll('[data-customer-stories-carousel]').forEach(function(root) {
    var slides = root.querySelectorAll('[data-customer-stories-slide]');
    if (slides.length < 2) return;

    var prevBtn = root.querySelector('[data-customer-stories-prev]');
    var nextBtn = root.querySelector('[data-customer-stories-next]');
    var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileQuery = window.matchMedia('(max-width: 768px)');
    var index = 0;
    var timer = null;
    var positionClasses = ['is-center', 'is-prev', 'is-next', 'is-prev-2', 'is-next-2', 'is-far'];

    function visibleRadius() {
      return mobileQuery.matches ? 1 : 2;
    }

    function shortestOffset(i, active, total) {
      var raw = i - active;
      if (raw > total / 2) raw -= total;
      if (raw < -total / 2) raw += total;
      return raw;
    }

    function setActive(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      var radius = visibleRadius();
      slides.forEach(function(slide, i) {
        var offset = shortestOffset(i, index, slides.length);
        positionClasses.forEach(function(cls) { slide.classList.remove(cls); });
        if (offset === 0) slide.classList.add('is-center');
        else if (offset === -1 && radius >= 1) slide.classList.add('is-prev');
        else if (offset === 1 && radius >= 1) slide.classList.add('is-next');
        else if (offset === -2 && radius >= 2) slide.classList.add('is-prev-2');
        else if (offset === 2 && radius >= 2) slide.classList.add('is-next-2');
        else slide.classList.add('is-far');
      });
    }

    function next() { setActive(index + 1); }
    function prev() { setActive(index - 1); }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!autoplay || reducedMotion) return;
      stop();
      timer = window.setInterval(next, interval);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); start(); });

    slides.forEach(function(slide) {
      slide.addEventListener('click', function(e) {
        if (slide.classList.contains('is-center')) return;
        if (e.target.closest('a, button')) return;
        var target = parseInt(slide.getAttribute('data-index') || '0', 10);
        setActive(target);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    function onViewportChange() {
      setActive(index);
    }
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onViewportChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(onViewportChange);
    }

    setActive(0);
    start();
  });
}

// Product variant helpers — used by cart drawer on product pages (must live in theme.js)
function getProductVariantsData() {
  var el = document.getElementById('productVariantsJson');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (err) {
    return null;
  }
}

function getSelectedProductVariantId() {
  var params = new URLSearchParams(window.location.search);
  var fromUrl = parseInt(params.get('variant'), 10);
  if (fromUrl) return fromUrl;
  var checked = document.querySelector('.product-variants__options input[name="id"]:checked');
  if (checked) return parseInt(checked.value, 10);
  var hidden = document.querySelector('#productForm input[name="id"]');
  if (hidden) return parseInt(hidden.value, 10);
  return null;
}

function cartAlertBusy() {
  window.alert(CART_BUSY_MSG);
}

function cartDrawerMoneyFormat() {
  var el = document.getElementById('cartDrawerMoneyFormat');
  if (!el) return '${{amount}}';
  try { return JSON.parse(el.textContent); } catch (e) { return '${{amount}}'; }
}

function cartDrawerFormatMoney(cents) {
  var format = cartDrawerMoneyFormat();
  var amount = (cents / 100).toFixed(2);
  var amountNoDecimals = String(Math.round(cents / 100));
  var amountComma = amount.replace('.', ',');
  var amountNoDecimalsComma = amountNoDecimals.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  var out = format;
  out = out.replace('{{amount_with_comma_separator}}', amountComma);
  out = out.replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsComma);
  out = out.replace('{{amount_no_decimals}}', amountNoDecimals);
  out = out.replace('{{amount_with_apostrophe_separator}}', amount.replace(/(\d)(?=(\d{3})+\.)/g, '$1\''));
  out = out.replace('{{amount}}', amount);
  return out;
}

function cartDrawerEscape(str) {
  if (str == null) return '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function cartDrawerLineWeight(variantId, quantity) {
  var weights = cartDrawerWeights();
  var s = weights[variantId];
  if (!s) return '';
  var m = String(s).match(/^([\d.]+)\s*(.+)$/);
  if (!m) return '';
  var val = parseFloat(m[1]);
  var unit = m[2].trim();
  if (isNaN(val) || val <= 0) return '';
  var total = Math.round(val * quantity * 100) / 100;
  return total + ' ' + unit;
}

function cartDrawerTrashIcon(size) {
  var s = size || 16;
  return (
    '<svg class="cart-trash" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<g class="cart-trash__lid">' +
        '<path d="M8 4.5h8"/>' +
        '<path d="M10.5 4.5V3.4a1.1 1.1 0 011.1-1.1h1.8a1.1 1.1 0 011.1 1.1V4.5"/>' +
      '</g>' +
      '<path class="cart-trash__body" d="M5 6.5h14"/>' +
      '<path class="cart-trash__body" d="M7 6.5v12.2a1.6 1.6 0 001.6 1.6h6.8a1.6 1.6 0 001.6-1.6V6.5"/>' +
      '<path class="cart-trash__body" d="M10 10.5v6M14 10.5v6"/>' +
    '</svg>'
  );
}

function cartDrawerSyncMinusState(row) {
  if (!row) return;
  var qtyInput = row.querySelector('[data-cart-drawer-qty]');
  var minus = row.querySelector('[data-cart-drawer-minus]');
  if (!qtyInput || !minus) return;
  var qty = parseInt(qtyInput.value, 10) || 1;
  minus.disabled = qty <= 1;
}

function cartDrawerIsB2b() {
  var drawer = document.getElementById('cartDrawer');
  return !!(drawer && drawer.getAttribute('data-b2b') === 'true');
}

function cartB2bLineProperties() {
  var data = typeof getProductVariantsData === 'function' ? getProductVariantsData() : null;
  if (!data || !data.is_b2b || !data.variants || !data.variants.length) return null;
  var variantId = typeof getSelectedProductVariantId === 'function' ? getSelectedProductVariantId() : null;
  var variant = data.variants.find(function(entry) { return entry.id === variantId; }) || data.variants[0];
  if (!cartVariantHasVolumePricing(variant)) return null;
  return { 'B2B pricing': 'Catalog / quantity pricing' };
}

function cartVariantHasVolumePricing(variant) {
  return !!(variant && variant.quantity_price_breaks && variant.quantity_price_breaks.length);
}

function cartItemHasVolumePricing(item) {
  var catalog = cartB2bCatalogMap()[item.variant_id] || {};
  if (catalog.has_breaks === true) return true;
  if (catalog.has_breaks === false) return false;
  return false;
}

function cartFormatDiscountDisplayTitle(title) {
  var cleaned = (title || '').toString().trim();
  if (!cleaned) return '';
  // Seed volume discounts are authored as "XP-VD: …" — strip the prefix only.
  if (/^XP-VD:/i.test(cleaned)) {
    return cleaned.replace(/^XP-VD:/i, '').trim();
  }
  return cleaned;
}

function cartDiscountIsProductScoped(app) {
  if (!app) return false;
  var rawTitle = (app.title || app.code || '').toString().trim();
  if (/^XP-VD:/i.test(rawTitle)) return true;
  var selection = (app.target_selection || '').toString();
  if (selection === 'entitled' || selection === 'explicit') return true;
  if (selection === 'all') return false;
  return false;
}

function cartDiscountIsOrderScoped(app) {
  if (!app) return false;
  return !cartDiscountIsProductScoped(app);
}

function cartItemDiscountTitles(item) {
  var titles = [];
  function pushTitle(title) {
    var cleaned = cartFormatDiscountDisplayTitle(title);
    if (!cleaned || titles.indexOf(cleaned) !== -1) return;
    titles.push(cleaned);
  }
  (item.discounts || []).forEach(function(discount) {
    pushTitle(discount.title);
  });
  (item.line_level_discount_allocations || []).forEach(function(alloc) {
    pushTitle(alloc.discount_application && alloc.discount_application.title);
  });
  return titles;
}

function cartItemProductDiscountTitles(item) {
  var titles = [];
  function pushCleaned(cleaned) {
    if (!cleaned || titles.indexOf(cleaned) !== -1) return;
    titles.push(cleaned);
  }
  (item.line_level_discount_allocations || []).forEach(function(alloc) {
    var app = alloc.discount_application || {};
    // Order-wide discounts can still appear as line allocations — keep those at Subtotal only.
    if ((app.target_selection || '') === 'all') return;
    if (!cartDiscountIsProductScoped(app) && app.target_selection) return;
    pushCleaned(cartFormatDiscountDisplayTitle(app.title || app.code || ''));
  });
  if (!titles.length) {
    (item.discounts || []).forEach(function(discount) {
      if (!discount || !discount.title) return;
      if (!/^XP-VD:/i.test(String(discount.title).trim())) return;
      pushCleaned(cartFormatDiscountDisplayTitle(discount.title));
    });
  }
  return titles;
}

function cartOrderDiscountTitles(cart) {
  var titles = [];
  function pushTitle(title) {
    var cleaned = cartFormatDiscountDisplayTitle(title);
    if (!cleaned || titles.indexOf(cleaned) !== -1) return;
    titles.push(cleaned);
  }
  if (!cart) return titles;
  (cart.cart_level_discount_applications || []).forEach(function(app) {
    if (!cartDiscountIsOrderScoped(app)) return;
    pushTitle(app && (app.title || app.code));
  });
  (cart.discount_applications || []).forEach(function(app) {
    if (!cartDiscountIsOrderScoped(app)) return;
    pushTitle(app && (app.title || app.code));
  });
  return titles;
}

function cartAppliedDiscountTitles(cart) {
  // Subtotal labels: order-scoped discounts only.
  return cartOrderDiscountTitles(cart);
}

var CART_DISCOUNT_ICON_SVG =
  '<svg class="cart-applied-discount__icon" width="14" height="14" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path fill-rule="evenodd" d="M4.5 2A2.5 2.5 0 0 0 2 4.5v3.382a2.5 2.5 0 0 0 .732 1.767l6.795 6.795a2.5 2.5 0 0 0 3.536 0l3.382-3.382a2.5 2.5 0 0 0 0-3.536L9.65 2.732A2.5 2.5 0 0 0 7.882 2H4.5Zm1.25 3.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"/>' +
  '</svg>';

function cartAppliedDiscountNamesHtml(cart) {
  var titles = cartAppliedDiscountTitles(cart);
  if (!titles.length) return '';
  return (
    '<div class="cart-applied-discounts">' +
      titles.map(function(title) {
        return (
          '<span class="cart-applied-discount">' +
            CART_DISCOUNT_ICON_SVG +
            '<span class="cart-applied-discount__text">' + cartDrawerEscape(title) + '</span>' +
          '</span>'
        );
      }).join('') +
    '</div>'
  );
}

function cartB2bCatalogMap() {
  var map = {};
  var el = document.getElementById('cartDrawerB2bCatalog');
  if (el) {
    try { map = JSON.parse(el.textContent) || {}; } catch (err) { map = {}; }
  }
  var data = typeof getProductVariantsData === 'function' ? getProductVariantsData() : null;
  if (data && data.variants) {
    data.variants.forEach(function(variant) {
      if (!variant) return;
      var hasBreaks = cartVariantHasVolumePricing(variant);
      if (!map[variant.id]) {
        var catalogUnit = variant.price || 0;
        (variant.quantity_price_breaks || []).forEach(function(priceBreak) {
          var breakCents = Number(priceBreak.price) || 0;
          if (breakCents > catalogUnit) catalogUnit = breakCents;
        });
        map[variant.id] = {
          catalog_unit: catalogUnit,
          compare_at: variant.compare_at_price || 0,
          has_breaks: hasBreaks
        };
      } else {
        map[variant.id].has_breaks = hasBreaks;
      }
    });
  }
  return map;
}

function cartItemWasLineCents(item) {
  var paidUnit = item.final_price != null ? item.final_price : item.price;
  var paidLine = item.final_line_price != null ? item.final_line_price : item.line_price;
  var catalog = cartB2bCatalogMap()[item.variant_id] || {};
  var compareAt = Number(catalog.compare_at) || item.variant_compare_at_price || 0;
  var catalogUnit = Number(catalog.catalog_unit) || 0;
  var wasUnit = 0;
  if (compareAt > paidUnit) wasUnit = compareAt;
  else if (catalogUnit > paidUnit) wasUnit = catalogUnit;
  else if (item.original_price && item.original_price > paidUnit) wasUnit = item.original_price;
  var wasLine = wasUnit > paidUnit ? wasUnit * item.quantity : 0;
  if (item.original_line_price && item.original_line_price > wasLine && item.original_line_price > paidLine) {
    wasLine = item.original_line_price;
  }
  return wasLine > paidLine ? wasLine : 0;
}

function cartB2bLabel(item, isB2b) {
  var titles = cartItemDiscountTitles(item);
  if (titles.length) return (isB2b ? 'B2B · ' : '') + titles.join(' · ');
  return isB2b ? 'B2B pricing' : '';
}

var cartDrawerLastCart = null;

function cartInventoryMap() {
  var el = document.getElementById('cartDrawerInventory');
  if (!el) return {};
  try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
}

function cartVariantInventoryLimit(variantId) {
  if (!variantId) return null;
  var info = cartInventoryMap()[variantId] || cartInventoryMap()[String(variantId)] || null;
  var data = typeof getProductVariantsData === 'function' ? getProductVariantsData() : null;
  if (data && data.variants && data.variants.length) {
    var match = data.variants.find(function(entry) { return Number(entry.id) === Number(variantId); });
    if (match) {
      info = {
        tracked: !!match.inventory_tracked,
        quantity: match.inventory_quantity
      };
    }
  }
  if (!info || !info.tracked) return null;
  var stock = parseInt(info.quantity, 10);
  if (isNaN(stock)) return null;
  return stock;
}

function cartQtyInCartForVariant(variantId, excludeKey) {
  var cart = cartDrawerLastCart;
  if (!cart || !cart.items || !cart.items.length) return 0;
  var total = 0;
  cart.items.forEach(function(item) {
    if (Number(item.variant_id) !== Number(variantId)) return;
    if (excludeKey && item.key === excludeKey) return;
    total += item.quantity || 0;
  });
  return total;
}

function cartStockMessage(limit) {
  var n = Math.max(0, parseInt(limit, 10) || 0);
  return 'Only ' + n + ' available in stock. Quantity has been restored.';
}

function cartAlertStock(limit) {
  window.alert(cartStockMessage(limit));
}

function cartDrawerEnsureCart() {
  if (cartDrawerLastCart) return Promise.resolve(cartDrawerLastCart);
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    })
    .then(function(cart) {
      cartDrawerLastCart = cart;
      return cart;
    });
}

function cartDrawerRenderItem(item, index) {
  var img = item.image ? item.image.replace(/(\.[^.]*)?$/, '_160x160$1') : '';
  var title = cartDrawerEscape(item.product_title);
  var variantTitle = item.variant_title && item.variant_title.indexOf('Default') === -1 ? '<p class="cart-drawer-item__variant">' + cartDrawerEscape(item.variant_title) + '</p>' : '';
  var lineTotal = cartDrawerFormatMoney(item.final_line_price);
  var isB2b = cartDrawerIsB2b();
  var showB2b = isB2b && cartItemHasVolumePricing(item);
  var wasLine = showB2b ? cartItemWasLineCents(item) : 0;
  var productDiscountTitles = cartItemProductDiscountTitles(item);
  var hasProductDiscount = productDiscountTitles.length > 0;
  var compare = '';
  var b2bTag = '';
  var b2bLabel = showB2b ? cartB2bLabel(item, true) : '';
  if (showB2b && b2bLabel) {
    b2bTag = '<span class="cart-b2b-tag">' + cartDrawerEscape(b2bLabel) + '</span>';
  }
  if (wasLine > item.final_line_price) {
    compare = '<span class="cart-drawer-item__compare">' + cartDrawerFormatMoney(wasLine) + '</span>';
  } else if (hasProductDiscount && item.original_line_price > item.final_line_price) {
    compare = '<span class="cart-drawer-item__compare">' + cartDrawerFormatMoney(item.original_line_price) + '</span>';
  } else if (!showB2b && item.variant_compare_at_price && item.variant_compare_at_price > item.variant_price) {
    compare = '<span class="cart-drawer-item__compare">' + cartDrawerFormatMoney(item.variant_compare_at_price * item.quantity) + '</span>';
  }
  if (hasProductDiscount && item.original_line_price > item.final_line_price) {
    lineTotal = '<span class="cart-drawer-item__line-total cart-drawer-item__line-total--discount">' + cartDrawerFormatMoney(item.final_line_price) + '</span>';
  } else {
    lineTotal = '<span class="cart-drawer-item__line-total">' + lineTotal + '</span>';
  }
  var lineWeight = cartDrawerLineWeight(item.variant_id, item.quantity);
  var weightHtml = lineWeight ? '<span class="cart-drawer-item__line-weight">' + cartDrawerEscape(lineWeight) + '</span>' : '';
  var stockLimit = cartVariantInventoryLimit(item.variant_id);
  var stockAttr = stockLimit == null ? '' : ' data-inventory-limit="' + stockLimit + '"';
  var lineDiscountHtml = '';
  if (productDiscountTitles.length) {
    lineDiscountHtml =
      '<div class="cart-drawer-item__discounts" aria-label="Product discounts">' +
        productDiscountTitles.map(function(discountTitle) {
          return (
            '<span class="cart-applied-discount">' +
              CART_DISCOUNT_ICON_SVG +
              '<span class="cart-applied-discount__text">' + cartDrawerEscape(discountTitle) + '</span>' +
            '</span>'
          );
        }).join('') +
      '</div>';
  }
  return '' +
    '<div class="cart-drawer-item" data-cart-drawer-item data-key="' + cartDrawerEscape(item.key) + '" data-variant-id="' + cartDrawerEscape(item.variant_id) + '" data-line="' + (index + 1) + '"' + stockAttr + '>' +
      '<div class="cart-drawer-item__image">' +
        (img ? '<img src="' + cartDrawerEscape(img) + '" alt="' + title + '" width="72" height="72" loading="lazy" />' : '') +
      '</div>' +
      '<div class="cart-drawer-item__body">' +
        '<div class="cart-drawer-item__row">' +
          '<div class="cart-drawer-item__info">' +
            '<h3 class="cart-drawer-item__title">' + title + '</h3>' +
            variantTitle +
            b2bTag +
          '</div>' +
          '<div class="cart-drawer-item__price">' + compare + lineTotal + weightHtml + '</div>' +
        '</div>' +
        '<div class="cart-drawer-item__controls">' +
          '<div class="cart-drawer-stepper" data-cart-drawer-stepper>' +
            '<button type="button" class="cart-drawer-stepper__btn" data-cart-drawer-minus aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
            '<input type="number" class="cart-drawer-stepper__input" value="' + item.quantity + '" min="1" data-cart-drawer-qty data-qty-last="' + item.quantity + '"' + (stockLimit == null ? '' : ' max="' + stockLimit + '"') + '>' +
            '<button type="button" class="cart-drawer-stepper__btn" data-cart-drawer-plus aria-label="Increase quantity"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '</div>' +
          '<button type="button" class="cart-drawer-item__remove" data-cart-drawer-remove>' +
            cartDrawerTrashIcon(16) +
            '<span>Remove</span>' +
          '</button>' +
        '</div>' +
        lineDiscountHtml +
      '</div>' +
    '</div>';
}

function cartDrawerWeights() {
  var el = document.getElementById('cartDrawerWeights');
  if (!el) return {};
  try { return JSON.parse(el.textContent); } catch (e) { return {}; }
}

function cartDrawerRecomputeWeight(cart) {
  var weights = cartDrawerWeights();
  var wrap = document.querySelector('[data-cart-drawer-weight]');
  if (!wrap) return;
  // weights[variantId] is a pre-formatted single-unit weight string from Liquid's weight_with_unit,
  // e.g. "0.1 kg". Parse the numeric value and unit, then sum same-unit items.
  var unit = '';
  var total = 0;
  cart.items.forEach(function(it) {
    var s = weights[it.variant_id];
    if (!s) return;
    var m = String(s).match(/^([\d.]+)\s*(.+)$/);
    if (!m) return;
    var val = parseFloat(m[1]);
    var u = m[2].trim();
    if (!unit) unit = u;
    if (u === unit && !isNaN(val)) total += val * it.quantity;
  });
  if (total > 0 && unit) {
    wrap.textContent = (Math.round(total * 100) / 100) + ' ' + unit;
  } else {
    wrap.textContent = '—';
  }
}

function syncCartDrawerMarqueeSpeed(root) {
  var scope = root || document;
  var track = scope.querySelector('.cart-drawer__marquee-track');
  if (!track) return;
  var set = track.querySelector('.cart-drawer__marquee-set');
  if (!set) return;
  var width = set.scrollWidth || set.offsetWidth || 0;
  if (!width) return;
  var items = set.querySelectorAll('.cart-drawer__marquee-item').length;
  // One loop covers one set (translateX -50%). Pace ~42px/s so short copy
  // does not blur and longer / multi-item copy still finishes in a reasonable time.
  var seconds = width / 42;
  if (items > 1) seconds += (items - 1) * 3.5;
  if (seconds < 12) seconds = 12;
  if (seconds > 48) seconds = 48;
  track.style.setProperty('--cart-marquee-duration', seconds.toFixed(1) + 's');
}

function initCartDiscounts() {
  var cartTagTmpl = document.getElementById('cartDiscountTagsTemplate');
  var cartMount = document.querySelector('[data-cart-discount-tags-mount]');
  if (cartTagTmpl && cartMount) {
    cartMount.replaceChildren(cartTagTmpl.content.cloneNode(true));
  }

  var marqueeTmpl = document.getElementById('cartDiscountMarqueeTemplate');
  var marqueeMount = document.querySelector('[data-cart-drawer-marquee-mount]');
  if (marqueeTmpl && marqueeMount) {
    marqueeMount.replaceChildren(marqueeTmpl.content.cloneNode(true));
    syncCartDrawerMarqueeSpeed(marqueeMount);
  }
}

function cartMarketCountryInList(code, marketsCsv) {
  if (!code) return false;
  var needle = String(code).toUpperCase();
  var markets = String(marketsCsv || '').split(',');
  for (var i = 0; i < markets.length; i++) {
    var iso = markets[i].replace(/\s+/g, '').toUpperCase();
    if (iso && iso === needle) return true;
  }
  return false;
}

function initCartMarketNotice() {
  var notices = document.querySelectorAll('[data-cart-market-notice]');
  if (!notices.length) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var url = root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false';

  fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function(res) {
      if (!res.ok) throw new Error('market notice lookup failed');
      return res.json();
    })
    .then(function(data) {
      var detected = (data && data.detected_values) || {};
      var country = detected.country || {};
      var code = country.handle || country.iso_code || detected.country_code || '';
      if (!code) return;

      Array.prototype.forEach.call(notices, function(el) {
        var inMarket = cartMarketCountryInList(code, el.getAttribute('data-market-countries'));
        if (!inMarket) el.hidden = false;
      });
    })
    .catch(function() {
      // Fail closed: keep notice hidden if GeoIP lookup is unavailable.
    });
}

function cartDrawerRefresh() {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(res) {
      // Defend against HTML responses (dev server errors, redirects).
      // Shopify returns JSON with content-type "text/javascript; charset=utf-8"
      // for the AJAX cart endpoints, so we can't strictly require application/json.
      if (!res.ok) throw new Error('Cart fetch failed');
      var ct = res.headers.get('content-type') || '';
      if (ct.indexOf('javascript') === -1 && ct.indexOf('json') === -1) {
        throw new Error('Unexpected cart response');
      }
      return res.json();
    })
    .then(function(cart) {
      cartDrawerLastCart = cart;
      var itemsWrap = document.querySelector('[data-cart-drawer-items]');
      var totalEl = document.querySelector('[data-cart-drawer-total]');
      var actionsEl = document.querySelector('[data-cart-drawer-actions]');
      var summaryEl = document.querySelector('[data-cart-drawer-summary]');
      var drawer = document.getElementById('cartDrawer');
      var hasItems = cart.items.length > 0;
      if (itemsWrap) {
        if (hasItems) {
          itemsWrap.innerHTML = cart.items.map(function(it, i) { return cartDrawerRenderItem(it, i); }).join('');
        } else {
          var shopUrl = (drawer && drawer.getAttribute('data-all-products-url')) || '/collections/all';
          var loginUrl = (drawer && drawer.getAttribute('data-login-url')) || '/account/login';
          var showLoginPrompt = drawer && drawer.hasAttribute('data-guest-checkout-prompt');
          var loginPromptHtml = showLoginPrompt
            ? '<p class="cart-drawer__empty-login">Have an account? <a href="' + cartDrawerEscape(loginUrl) + '">Log in</a> to check out faster.</p>'
            : '';
          itemsWrap.innerHTML =
            '<div class="cart-drawer__empty-state">' +
              '<h2 class="cart-drawer__empty">Your cart is empty</h2>' +
              loginPromptHtml +
              '<a href="' + cartDrawerEscape(shopUrl) + '" class="btn cart-drawer__btn cart-drawer__btn--continue" data-cart-drawer-continue>Continue shopping</a>' +
            '</div>';
        }
      }
      if (actionsEl) actionsEl.hidden = !hasItems;
      if (summaryEl) summaryEl.hidden = !hasItems;
      if (totalEl) {
        var isB2b = cartDrawerIsB2b();
        var b2bWasTotal = 0;
        var b2bHasCompare = false;
        var b2bHasVolume = false;
        if (isB2b && cart.items && cart.items.length) {
          cart.items.forEach(function(item) {
            if (!cartItemHasVolumePricing(item)) {
              b2bWasTotal += item.final_line_price;
              return;
            }
            b2bHasVolume = true;
            var wasLine = cartItemWasLineCents(item);
            if (wasLine > item.final_line_price) {
              b2bHasCompare = true;
              b2bWasTotal += wasLine;
            } else {
              b2bWasTotal += item.final_line_price;
            }
          });
        }
        var discountNamesHtml = cartAppliedDiscountNamesHtml(cart);
        if (isB2b && b2bHasVolume) {
          totalEl.innerHTML =
            discountNamesHtml +
            '<span class="cart-b2b-tag">B2B pricing</span>' +
            (b2bHasCompare ? '<span class="cart-discount-original">' + cartDrawerFormatMoney(b2bWasTotal) + '</span>' : '') +
            '<span class="cart-discount-final">' + cartDrawerFormatMoney(cart.total_price) + '</span>';
        } else if (cart.total_discount && cart.total_discount > 0) {
          totalEl.innerHTML =
            discountNamesHtml +
            '<span class="cart-discount-original">' + cartDrawerFormatMoney(cart.original_total_price) + '</span>' +
            '<span class="cart-discount-final">' + cartDrawerFormatMoney(cart.total_price) + '</span>';
        } else {
          totalEl.textContent = cartDrawerFormatMoney(cart.total_price);
        }
      }
      cartDrawerRecomputeWeight(cart);

      // Keep the header cart count in sync after every AJAX cart change
      var headerCount = document.querySelector('.site-header__cart-count');
      if (headerCount) {
        headerCount.textContent = cart.item_count;
        headerCount.style.display = cart.item_count > 0 ? '' : 'none';
      }
    });
}

function cartDrawerPrefersReducedMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function cartDrawerShow() {
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  initCartDiscounts();
  drawer.hidden = false;
  document.body.classList.add('cart-drawer-open');
  lockPageScroll(drawer, drawer.querySelector('.cart-drawer__panel'));
  if (cartDrawerPrefersReducedMotion()) {
    drawer.classList.add('is-open');
    return;
  }
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      drawer.classList.add('is-open');
    });
  });
}

function cartDrawerOpen() {
  cartDrawerShow();
  cartDrawerRefresh().catch(function() {});
}

function cartDrawerClose() {
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  document.body.classList.remove('cart-drawer-open');
  unlockPageScroll(drawer);
  if (cartDrawerPrefersReducedMotion()) {
    drawer.hidden = true;
    return;
  }
  var panel = drawer.querySelector('.cart-drawer__panel');
  var finished = false;
  function finish() {
    if (finished) return;
    finished = true;
    if (panel) panel.removeEventListener('transitionend', onEnd);
    if (!drawer.classList.contains('is-open')) drawer.hidden = true;
  }
  function onEnd(e) {
    if (e.target !== panel) return;
    finish();
  }
  if (panel) panel.addEventListener('transitionend', onEnd);
  window.setTimeout(finish, 480);
}

// === Cart drawer: change quantity with debounce (anti-shake) + global busy lock ===
var cartStepperTimers = {};   // { line: timerId }  — debounce timers per line
var cartStepperTarget = {};   // { line: targetQty } — pending target quantity
var cartStepperFetching = false; // lock during fetch, prevents concurrent /cart/change.js

function cartDrawerSetBusy(busy) {
  var drawer = document.getElementById('cartDrawer');
  if (drawer) drawer.classList.toggle('is-busy', !!busy);
}

function cartDoChangeQuantity() {
  var lines = Object.keys(cartStepperTarget);
  if (!lines.length || cartStepperFetching) return;
  cartStepperFetching = true;
  cartDrawerSetBusy(true);

  var line = parseInt(lines[0], 10);
  var quantity = cartStepperTarget[line];
  delete cartStepperTarget[line];
  window.clearTimeout(cartStepperTimers[line]);
  delete cartStepperTimers[line];

  var safety = window.setTimeout(function() {
    cartStepperFetching = false;
    cartDrawerSetBusy(false);
  }, 5000);

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
    .then(function(res) {
      if (!res.ok) {
        return res.text().then(function(body) {
          var msg = '';
          try { var d = JSON.parse(body); msg = d.description || d.message || ''; } catch (e) {}
          throw { message: msg };
        });
      }
      return cartDrawerRefresh();
    })
    .then(function() {
      window.clearTimeout(safety);
      cartStepperFetching = false;
      cartDrawerSetBusy(false);
      cartDoChangeQuantity();
    })
    .catch(function(err) {
      window.clearTimeout(safety);
      cartStepperFetching = false;
      cartDrawerSetBusy(false);
      window.alert((err && err.message) ? err.message : CART_BUSY_MSG);
      cartDrawerRefresh().then(function() {}, function() {});
      cartDoChangeQuantity();
    });
}

function cartDrawerFadeOut(row, done) {
  if (!row) {
    if (done) done();
    return;
  }
  if (row.classList.contains('is-removing')) {
    if (done) done();
    return;
  }
  if (cartDrawerPrefersReducedMotion()) {
    row.classList.add('is-removing');
    if (done) done();
    return;
  }

  var finished = false;
  function finish() {
    if (finished) return;
    finished = true;
    row.removeEventListener('transitionend', onEnd);
    if (done) done();
  }
  function onEnd(e) {
    if (e.target !== row) return;
    finish();
  }
  row.addEventListener('transitionend', onEnd);
  void row.offsetWidth;
  row.classList.add('is-removing');
  window.setTimeout(finish, 360);
}

function cartDrawerRestoreRow(row) {
  if (!row) return;
  row.classList.remove('is-removing');
}

function cartDrawerChangeQuantity(line, quantity) {
  if (cartStepperFetching) {
    cartStepperTarget[line] = quantity;
    return;
  }
  cartStepperTarget[line] = quantity;
  window.clearTimeout(cartStepperTimers[line]);
  cartStepperTimers[line] = window.setTimeout(function() {
    delete cartStepperTimers[line];
    cartDoChangeQuantity();
  }, 400);
}

function cartDrawerRemoveLine(row, line) {
  if (!row || cartStepperFetching) return;
  cartStepperFetching = true;
  cartDrawerSetBusy(true);
  cartDrawerFadeOut(row, function() {
    var safety = window.setTimeout(function() {
      cartStepperFetching = false;
      cartDrawerSetBusy(false);
      cartDrawerRestoreRow(row);
    }, 5000);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function(res) {
        if (!res.ok) throw new Error('remove failed');
        return cartDrawerRefresh();
      })
      .then(function() {
        window.clearTimeout(safety);
        cartStepperFetching = false;
        cartDrawerSetBusy(false);
        cartDoChangeQuantity();
      })
      .catch(function() {
        window.clearTimeout(safety);
        cartStepperFetching = false;
        cartDrawerSetBusy(false);
        cartDrawerRestoreRow(row);
        cartAlertBusy();
      });
  });
}

function initSeedsRail() {
  var roots = document.querySelectorAll('[data-seeds-rail]');
  if (!roots.length) return;

  roots.forEach(function(root) {
    if (root.dataset.seedsRailBound === 'true') return;
    root.dataset.seedsRailBound = 'true';

    var openBtn = root.querySelector('[data-seeds-rail-open]');
    var shell = root.querySelector('[data-seeds-rail-shell]');
    var panel = root.querySelector('[data-seeds-rail-panel]');
    var body = root.querySelector('[data-seeds-rail-body]');
    var grid = root.querySelector('[data-seeds-rail-grid]');
    var statusEl = root.querySelector('[data-seeds-rail-status]');
    var sectionId = root.getAttribute('data-section-id') || '';
    var loading = false;
    var observer = null;

    function isOpen() {
      return root.classList.contains('is-open');
    }

    function setStatus(visible, text) {
      if (!statusEl) return;
      if (text) statusEl.textContent = text;
      if (visible) statusEl.removeAttribute('hidden');
      else statusEl.setAttribute('hidden', '');
    }

    function mountDeferredCards() {
      var tpl = root.querySelector('[data-seeds-rail-template]');
      if (!tpl || !grid || !tpl.content) return false;
      while (tpl.content.firstChild) {
        grid.appendChild(tpl.content.firstChild);
      }
      tpl.remove();
      root.removeAttribute('data-seeds-rail-deferred');
      if (typeof initProductCardVideos === 'function') {
        initProductCardVideos(grid);
      }
      return true;
    }

    function openRail() {
      if (!shell || !panel) return;
      shell.hidden = false;
      // Force layout before open class for transition
      void shell.offsetWidth;
      root.classList.add('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      lockPageScroll(root, panel);
      try {
        panel.focus({ preventScroll: true });
      } catch (err) {
        panel.focus();
      }

      if (root.getAttribute('data-seeds-rail-deferred') === 'true') {
        mountDeferredCards();
      } else if (grid && !grid.children.length) {
        // Fallback if deferred template missing (e.g. edge HTML).
        appendPage(1).then(function() {
          observeSentinel();
        });
        return;
      }
      observeSentinel();
    }

    function closeRail() {
      root.classList.remove('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      unlockPageScroll(root);
      if (shell) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          shell.hidden = true;
        } else {
          window.setTimeout(function() {
            if (!isOpen()) shell.hidden = true;
          }, 380);
        }
      }
      if (openBtn) {
        try {
          openBtn.focus({ preventScroll: true });
        } catch (err) {
          openBtn.focus();
        }
      }
    }

    function shopRootUrl() {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        return new URL(base, window.location.origin);
      } catch (err) {
        return new URL('/', window.location.origin);
      }
    }

    function appendPage(page) {
      if (loading || !sectionId || !grid) return Promise.resolve();
      loading = true;
      setStatus(true, 'Loading…');

      var url = shopRootUrl();
      url.searchParams.set('sections', sectionId);
      url.searchParams.set('page', String(page));

      return fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function(res) {
          if (!res.ok) throw new Error('Seeds rail page failed');
          return res.json();
        })
        .then(function(data) {
          var html = data && data[sectionId];
          if (!html) throw new Error('Seeds rail section missing');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var remoteGrid = doc.querySelector('[data-seeds-rail-grid]');
          var remoteTpl = doc.querySelector('[data-seeds-rail-template]');
          var remoteSentinel = doc.querySelector('[data-seeds-rail-sentinel]');
          var sourceNodes = null;
          if (remoteGrid && remoteGrid.children.length) {
            sourceNodes = remoteGrid.children;
          } else if (remoteTpl && remoteTpl.content && remoteTpl.content.children.length) {
            sourceNodes = remoteTpl.content.children;
          }
          if (!sourceNodes) throw new Error('Seeds rail products missing');

          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(sourceNodes, function(child) {
            frag.appendChild(document.importNode(child, true));
          });
          var appended = frag.childNodes.length;
          grid.appendChild(frag);

          if (typeof initProductCardVideos === 'function') {
            initProductCardVideos(grid);
          }

          var liveSentinel = root.querySelector('[data-seeds-rail-sentinel]');
          if (remoteSentinel && remoteSentinel.getAttribute('data-next-page')) {
            if (!liveSentinel) {
              liveSentinel = document.createElement('div');
              liveSentinel.className = 'seeds-rail__sentinel';
              liveSentinel.setAttribute('data-seeds-rail-sentinel', '');
              liveSentinel.setAttribute('aria-hidden', 'true');
              if (statusEl && statusEl.parentNode) {
                statusEl.parentNode.insertBefore(liveSentinel, statusEl);
              } else if (body) {
                body.appendChild(liveSentinel);
              }
            }
            liveSentinel.setAttribute('data-next-page', remoteSentinel.getAttribute('data-next-page'));
          } else if (liveSentinel) {
            liveSentinel.remove();
          }

          root.setAttribute('data-page', String(page));
          setStatus(false);
          if (!appended && liveSentinel) liveSentinel.remove();
          observeSentinel();
        })
        .catch(function() {
          setStatus(true, 'Could not load more');
        })
        .then(function() {
          loading = false;
        });
    }

    function observeSentinel() {
      var sentinel = root.querySelector('[data-seeds-rail-sentinel]');
      if (!sentinel || !('IntersectionObserver' in window)) {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        return;
      }
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting || !isOpen() || loading) return;
            var next = parseInt(entry.target.getAttribute('data-next-page') || '', 10);
            if (!next || next < 2 || next === parseInt(root.getAttribute('data-page') || '0', 10)) return;
            appendPage(next);
          });
        },
        { root: body || null, rootMargin: '120px 0px', threshold: 0 }
      );
      observer.observe(sentinel);
    }

    if (openBtn) {
      openBtn.addEventListener('click', function() {
        if (isOpen()) closeRail();
        else openRail();
      });
    }

    root.addEventListener('click', function(e) {
      if (e.target.closest('[data-seeds-rail-close]')) {
        e.preventDefault();
        closeRail();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen()) {
        e.preventDefault();
        closeRail();
      }
    });
  });
}

if (!window.__seedsRailSectionLoadBound) {
  window.__seedsRailSectionLoadBound = true;
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-seeds-rail]')) {
      initSeedsRail();
    }
  });
}

function initCartDrawer() {
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  var checkoutForm = document.getElementById('CartDrawer-Form');
  if (checkoutForm) {
    checkoutForm.addEventListener('submit', function(event) {
      if (cartStepperFetching || Object.keys(cartStepperTarget).length) {
        event.preventDefault();
        window.alert(CART_BUSY_MSG);
      }
    });
  }

  // Intercept Add to Cart (button click, not form submit — avoids POST navigation history)
  var addBtn = document.getElementById('productAddBtn');
  if (addBtn) {
    addBtn.addEventListener('click', function(e) {
      e.preventDefault();
      cartDrawerAddToCart();
    });
  }

  // Close interactions
  drawer.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-close]')) cartDrawerClose();
    if (e.target === drawer) cartDrawerClose();
    var continueLink = e.target.closest('[data-cart-drawer-continue]');
    if (continueLink) {
      e.preventDefault();
      cartDrawerClose();
      window.location.href = continueLink.getAttribute('href') || '/collections/all';
    }
  });
  document.addEventListener('keydown', function(e) {
    if (!drawer.hidden && e.key === 'Escape') cartDrawerClose();
  });

  // Header cart icon: open the drawer instead of navigating to /cart
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-cart-drawer-open]');
    if (!trigger) return;
    e.preventDefault();
    cartDrawerOpen();
  });

  // Stepper + remove (delegated). Qty never goes below 1 except via Remove.
  drawer.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-cart-drawer-minus]');
    var plus = e.target.closest('[data-cart-drawer-plus]');
    var remove = e.target.closest('[data-cart-drawer-remove]');
    if (!minus && !plus && !remove) return;
    var row = e.target.closest('[data-cart-drawer-item]');
    if (!row || row.classList.contains('is-removing')) return;
    var rows = Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-drawer-item]:not(.is-removing)'));
    var line = rows.indexOf(row) + 1;
    if (line < 1) return;
    var qtyInput = row.querySelector('[data-cart-drawer-qty]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var previous = qtyInput ? (parseInt(qtyInput.getAttribute('data-qty-last'), 10) || qty) : qty;

    if (remove) {
      cartDrawerRemoveLine(row, line);
      return;
    }

    var target = qty;
    if (minus) target = Math.max(1, qty - 1);
    if (plus) target = qty + 1;
    if (target === qty) return;

    var variantId = row.getAttribute('data-variant-id');
    var lineKey = row.getAttribute('data-key');
    var limit = cartVariantInventoryLimit(variantId);
    if (limit != null) {
      var allowed = Math.max(0, limit - cartQtyInCartForVariant(variantId, lineKey));
      if (target > allowed) {
        cartAlertStock(limit);
        if (qtyInput) qtyInput.value = previous;
        cartDrawerSyncMinusState(row);
        return;
      }
    }

    if (qtyInput) {
      qtyInput.value = target;
      qtyInput.setAttribute('data-qty-last', String(target));
    }
    cartDrawerSyncMinusState(row);
    cartDrawerChangeQuantity(line, target);
  });
  drawer.addEventListener('change', function(e) {
    var qtyInput = e.target.closest('[data-cart-drawer-qty]');
    if (!qtyInput) return;
    var row = qtyInput.closest('[data-cart-drawer-item]');
    if (!row || row.classList.contains('is-removing')) return;
    var rows = Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-drawer-item]:not(.is-removing)'));
    var line = rows.indexOf(row) + 1;
    if (line < 1) return;
    var previous = parseInt(qtyInput.getAttribute('data-qty-last'), 10) || 1;
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    var variantId = row.getAttribute('data-variant-id');
    var lineKey = row.getAttribute('data-key');
    var limit = cartVariantInventoryLimit(variantId);
    if (limit != null) {
      var allowed = Math.max(0, limit - cartQtyInCartForVariant(variantId, lineKey));
      if (qty > allowed) {
        cartAlertStock(limit);
        qtyInput.value = previous;
        cartDrawerSyncMinusState(row);
        return;
      }
    }
    qtyInput.value = qty;
    qtyInput.setAttribute('data-qty-last', String(qty));
    cartDrawerSyncMinusState(row);
    cartDrawerChangeQuantity(line, qty);
  });
}

// Unified message for any cart-mutation request that fails.
var CART_BUSY_MSG = 'You are performing actions too quickly. Please refresh the page and try again.';

// === Add to Cart: disable + "Adding…" + safety timeout, then open drawer ===
function cartDrawerAddToCart() {
  var addBtn = document.getElementById('productAddBtn');
  var addText = document.getElementById('productAddBtnText');
  if (!addBtn || addBtn.disabled) return;
  var variantId = getSelectedProductVariantId();
  if (!variantId) return;
  var qtyInput = document.getElementById('qtyInput');
  var qtyNum = document.getElementById('qtyNum');
  var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  if (qtyNum && qtyNum.value != null) {
    quantity = parseInt(qtyNum.value, 10) || quantity;
  }
  var previousQty = quantity;

  var origText = addText ? addText.textContent : '';
  if (addText) addText.textContent = 'Adding…';
  addBtn.disabled = true;

  var safety = window.setTimeout(function() {
    if (addText) addText.textContent = origText;
    addBtn.disabled = false;
  }, 5000);

  function restoreAddBtn() {
    window.clearTimeout(safety);
    if (addText) addText.textContent = origText;
    addBtn.disabled = false;
  }

  cartDrawerEnsureCart()
    .catch(function() { return cartDrawerLastCart; })
    .then(function() {
      var limit = cartVariantInventoryLimit(variantId);
      if (limit != null) {
        var inCart = cartQtyInCartForVariant(variantId);
        var allowed = Math.max(0, limit - inCart);
        if (quantity > allowed) {
          cartAlertStock(limit);
          if (typeof setProductQty === 'function') {
            setProductQty(allowed > 0 ? allowed : previousQty);
          } else if (qtyInput) {
            qtyInput.value = String(allowed > 0 ? allowed : previousQty);
          }
          restoreAddBtn();
          return { aborted: true };
        }
      }

      var addPayload = { items: [{ id: variantId, quantity: quantity }] };
      var b2bProps = cartB2bLineProperties();
      if (b2bProps) addPayload.items[0].properties = b2bProps;

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addPayload)
      }).then(function(res) {
        if (!res.ok) {
          return res.text().then(function(body) {
            var msg = '';
            try { var d = JSON.parse(body); msg = d.description || d.message || ''; } catch (e) {}
            throw { message: msg, stock: /stock|inventor|available|sold out/i.test(msg) };
          });
        }
        return cartDrawerRefresh().then(function() {}, function() {});
      });
    })
    .then(function(result) {
      if (result && result.aborted) return;
      restoreAddBtn();
      cartDrawerShow();
    })
    .catch(function(err) {
      restoreAddBtn();
      if (err && err.stock && typeof setProductQty === 'function') {
        var limit = cartVariantInventoryLimit(variantId);
        if (limit != null) {
          setProductQty(Math.min(previousQty, Math.max(0, limit - cartQtyInCartForVariant(variantId)) || previousQty));
        }
      }
      var msg = err && err.message;
      window.alert(msg ? msg : CART_BUSY_MSG);
    });
}


function initImageLightbox() {
  document.querySelectorAll('[data-export-lightbox]').forEach(initOneImageLightbox);
}

/** @deprecated Use initImageLightbox — kept as alias for older call sites */
function initExportLicenseLightbox() {
  initImageLightbox();
}

function initOneImageLightbox(root) {
  if (!root || root.dataset.lightboxBound === 'true') return;

  var modal = root.querySelector('[data-export-lightbox-modal]');
  var triggers = root.querySelectorAll('[data-export-lightbox-trigger]');
  if (!modal || !triggers.length) return;

  root.dataset.lightboxBound = 'true';

  var frame = modal.querySelector('.export-lightbox__frame');
  var image = modal.querySelector('.export-lightbox__image');
  var caption = modal.querySelector('.export-lightbox__caption');
  var prevBtn = modal.querySelector('[data-export-lightbox-prev]');
  var nextBtn = modal.querySelector('[data-export-lightbox-next]');
  var zoomOutBtn = modal.querySelector('[data-export-lightbox-zoom-out]');
  var zoomInBtn = modal.querySelector('[data-export-lightbox-zoom-in]');
  var zoomResetBtn = modal.querySelector('[data-export-lightbox-zoom-reset]');
  var zoomStatus = modal.querySelector('[data-export-lightbox-zoom-status]');
  var closeEls = modal.querySelectorAll('[data-export-lightbox-close]');
  var items = Array.prototype.map.call(triggers, function(trigger) {
    return {
      src: trigger.getAttribute('data-src'),
      caption: trigger.getAttribute('data-caption') || '',
      group: trigger.getAttribute('data-lightbox-group') || '__all__',
      trigger: trigger
    };
  });
  var currentIndex = 0;
  var groupIndexes = [];
  var lastFocus = null;
  var loadToken = 0;
  var minScale = 1;
  var maxScale = 4;
  var scale = minScale;
  var panX = 0;
  var panY = 0;
  var pointers = new Map();
  var dragStart = null;
  var pinchStart = null;
  var gestureMoved = false;
  var suppressClick = false;
  var lastTouchTap = 0;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function clampPan() {
    if (!frame || !image || scale <= minScale) {
      panX = 0;
      panY = 0;
      return;
    }

    var maxX = Math.max(0, ((image.offsetWidth * scale) - frame.clientWidth) / 2);
    var maxY = Math.max(0, ((image.offsetHeight * scale) - frame.clientHeight) / 2);
    panX = clamp(panX, -maxX, maxX);
    panY = clamp(panY, -maxY, maxY);
  }

  function updateZoomUi() {
    var isZoomed = scale > minScale + 0.01;
    if (zoomStatus) zoomStatus.textContent = Math.round(scale * 100) + '%';
    if (zoomOutBtn) zoomOutBtn.disabled = !isZoomed;
    if (zoomResetBtn) zoomResetBtn.disabled = !isZoomed;
    if (zoomInBtn) zoomInBtn.disabled = scale >= maxScale - 0.01;
    if (frame) {
      frame.classList.toggle('is-zoomed', isZoomed);
      frame.setAttribute('aria-label', isZoomed ? 'Zoomed image. Drag to move.' : 'Image preview. Click or double tap to zoom.');
    }
  }

  function applyZoom(shouldClamp) {
    if (!image) return;
    if (shouldClamp !== false) clampPan();
    image.style.transform = 'translate3d(' + panX + 'px, ' + panY + 'px, 0) scale(' + scale + ')';
    updateZoomUi();
  }

  function resetZoom() {
    scale = minScale;
    panX = 0;
    panY = 0;
    pointers.clear();
    dragStart = null;
    pinchStart = null;
    gestureMoved = false;
    suppressClick = false;
    if (frame) frame.classList.remove('is-interacting');
    applyZoom(false);
  }

  function setScale(nextScale, pointX, pointY) {
    var oldScale = scale;
    var boundedScale = clamp(nextScale, minScale, maxScale);
    if (Math.abs(boundedScale - oldScale) < 0.001) return;

    if (frame && typeof pointX === 'number' && typeof pointY === 'number') {
      var rect = frame.getBoundingClientRect();
      var relativeX = pointX - (rect.left + rect.width / 2);
      var relativeY = pointY - (rect.top + rect.height / 2);
      var ratio = boundedScale / oldScale;
      panX = relativeX - ((relativeX - panX) * ratio);
      panY = relativeY - ((relativeY - panY) * ratio);
    }

    scale = boundedScale;
    if (scale <= minScale + 0.01) {
      scale = minScale;
      panX = 0;
      panY = 0;
    }
    applyZoom();
  }

  function toggleZoom(pointX, pointY) {
    setScale(scale > minScale + 0.01 ? minScale : 2, pointX, pointY);
  }

  function pointerDistance(first, second) {
    var dx = second.x - first.x;
    var dy = second.y - first.y;
    return Math.sqrt((dx * dx) + (dy * dy));
  }

  function pointerCenter(first, second) {
    return { x: (first.x + second.x) / 2, y: (first.y + second.y) / 2 };
  }

  function rebuildGroup(group) {
    groupIndexes = [];
    items.forEach(function(item, i) {
      if (item.group === group) groupIndexes.push(i);
    });
    if (!groupIndexes.length) {
      items.forEach(function(_, i) { groupIndexes.push(i); });
    }
  }

  function hasMultiple() {
    return groupIndexes.length > 1;
  }

  function updateNav() {
    var showNav = hasMultiple();
    if (prevBtn) prevBtn.hidden = !showNav;
    if (nextBtn) nextBtn.hidden = !showNav;
  }

  function setLoading(loading) {
    if (frame) frame.classList.toggle('is-loading', loading);
    if (image) image.classList.toggle('is-ready', !loading);
  }

  function render(index) {
    var item = items[index];
    if (!item || !image) return;
    currentIndex = index;
    resetZoom();
    updateNav();

    if (caption) {
      caption.textContent = item.caption;
      caption.hidden = !item.caption;
    }

    if (!item.src) {
      setLoading(false);
      image.removeAttribute('src');
      image.alt = item.caption || '';
      return;
    }

    var token = ++loadToken;
    image.classList.remove('is-ready');
    image.alt = item.caption || '';

    var triggerImage = item.trigger && item.trigger.querySelector('img');
    var previewSrc = '';
    if (triggerImage && triggerImage.complete && triggerImage.naturalWidth > 0) {
      previewSrc = triggerImage.currentSrc || triggerImage.src || '';
    }

    function finishLoad() {
      if (token !== loadToken) return;
      setLoading(false);
    }

    function loadFullImageInBackground() {
      if (!item.src || previewSrc === item.src) return;
      var fullImage = new Image();
      fullImage.decoding = 'async';
      fullImage.onload = function() {
        if (token !== loadToken) return;
        image.onload = finishLoad;
        image.onerror = finishLoad;
        image.src = item.src;
        if (image.complete && image.naturalWidth > 0) finishLoad();
      };
      fullImage.onerror = function() {
        // Keep the already-visible gallery preview if the high-resolution
        // upgrade cannot be fetched.
      };
      fullImage.src = item.src;
    }

    if (previewSrc) {
      image.onload = finishLoad;
      image.onerror = finishLoad;
      image.src = previewSrc;
      image.classList.add('is-ready');
      setLoading(false);
      loadFullImageInBackground();
      return;
    }

    setLoading(true);

    image.onload = finishLoad;
    image.onerror = finishLoad;

    if (image.getAttribute('src') === item.src && image.complete && image.naturalWidth > 0) {
      finishLoad();
      return;
    }

    image.src = item.src;
    if (image.complete && image.naturalWidth > 0) {
      finishLoad();
    }
  }

  function open(index) {
    lastFocus = document.activeElement;
    rebuildGroup(items[index].group);
    // Escape transform/overflow ancestors (e.g. .reveal) so fixed overlay is viewport-wide
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.classList.add('export-lightbox-open');
    render(index);
    var closeBtn = modal.querySelector('.export-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    loadToken += 1;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.classList.remove('export-lightbox-open');
    resetZoom();
    setLoading(true);
    if (image) {
      image.onload = null;
      image.onerror = null;
      image.classList.remove('is-ready');
      image.removeAttribute('src');
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function step(delta) {
    if (!hasMultiple()) return;
    var pos = groupIndexes.indexOf(currentIndex);
    if (pos < 0) pos = 0;
    var nextPos = (pos + delta + groupIndexes.length) % groupIndexes.length;
    render(groupIndexes[nextPos]);
  }

  triggers.forEach(function(trigger, index) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      open(index);
    });
  });

  closeEls.forEach(function(el) {
    el.addEventListener('click', close);
  });

  if (prevBtn) prevBtn.addEventListener('click', function() { step(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { step(1); });

  if (zoomOutBtn) zoomOutBtn.addEventListener('click', function() { setScale(scale - 0.5); });
  if (zoomInBtn) zoomInBtn.addEventListener('click', function() { setScale(scale + 0.5); });
  if (zoomResetBtn) zoomResetBtn.addEventListener('click', resetZoom);

  if (frame && image) {
    image.addEventListener('click', function(e) {
      if (suppressClick) {
        suppressClick = false;
        return;
      }
      toggleZoom(e.clientX, e.clientY);
    });

    frame.addEventListener('wheel', function(e) {
      if (modal.hidden) return;
      e.preventDefault();
      setScale(scale + (e.deltaY < 0 ? 0.25 : -0.25), e.clientX, e.clientY);
    }, { passive: false });

    frame.addEventListener('pointerdown', function(e) {
      if (modal.hidden || e.button > 0) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY, startX: e.clientX, startY: e.clientY });
      gestureMoved = false;
      suppressClick = false;
      if (typeof frame.setPointerCapture === 'function') frame.setPointerCapture(e.pointerId);

      if (pointers.size === 1) {
        dragStart = { x: e.clientX, y: e.clientY, panX: panX, panY: panY };
      } else if (pointers.size === 2) {
        var pair = Array.from(pointers.values());
        var center = pointerCenter(pair[0], pair[1]);
        pinchStart = {
          distance: Math.max(1, pointerDistance(pair[0], pair[1])),
          scale: scale,
          centerX: center.x,
          centerY: center.y,
          panX: panX,
          panY: panY
        };
      }
      frame.classList.add('is-interacting');
    });

    frame.addEventListener('pointermove', function(e) {
      var point = pointers.get(e.pointerId);
      if (!point) return;
      point.x = e.clientX;
      point.y = e.clientY;
      if (Math.abs(point.x - point.startX) > 4 || Math.abs(point.y - point.startY) > 4) {
        gestureMoved = true;
      }

      if (pointers.size >= 2 && pinchStart) {
        var pair = Array.from(pointers.values()).slice(0, 2);
        var center = pointerCenter(pair[0], pair[1]);
        var nextScale = clamp(pinchStart.scale * (pointerDistance(pair[0], pair[1]) / pinchStart.distance), minScale, maxScale);
        var rect = frame.getBoundingClientRect();
        var startRelativeX = pinchStart.centerX - (rect.left + rect.width / 2);
        var startRelativeY = pinchStart.centerY - (rect.top + rect.height / 2);
        var currentRelativeX = center.x - (rect.left + rect.width / 2);
        var currentRelativeY = center.y - (rect.top + rect.height / 2);
        var ratio = nextScale / pinchStart.scale;
        scale = nextScale;
        panX = currentRelativeX - ((startRelativeX - pinchStart.panX) * ratio);
        panY = currentRelativeY - ((startRelativeY - pinchStart.panY) * ratio);
        applyZoom(false);
      } else if (pointers.size === 1 && dragStart && scale > minScale) {
        panX = dragStart.panX + (e.clientX - dragStart.x);
        panY = dragStart.panY + (e.clientY - dragStart.y);
        applyZoom(false);
      }
    });

    function endPointer(e) {
      var point = pointers.get(e.pointerId);
      var isTouchTap = point && e.pointerType === 'touch' && !gestureMoved && pointers.size === 1;
      pointers.delete(e.pointerId);

      if (pointers.size === 1) {
        var remaining = Array.from(pointers.values())[0];
        dragStart = { x: remaining.x, y: remaining.y, panX: panX, panY: panY };
        pinchStart = null;
      } else if (!pointers.size) {
        frame.classList.remove('is-interacting');
        clampPan();
        applyZoom(false);
        suppressClick = gestureMoved || e.pointerType === 'touch';
        dragStart = null;
        pinchStart = null;

        if (isTouchTap) {
          var now = Date.now();
          if (now - lastTouchTap < 320) {
            toggleZoom(e.clientX, e.clientY);
            lastTouchTap = 0;
          } else {
            lastTouchTap = now;
          }
        }
      }
    }

    frame.addEventListener('pointerup', endPointer);
    frame.addEventListener('pointercancel', endPointer);
    window.addEventListener('resize', function() {
      if (!modal.hidden) applyZoom();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      step(-1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      step(1);
    }
  });
}


function initProductCardVideos(root) {
  var scope = root || document;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function bindVideoCard(cover) {
    if (cover.dataset.videoBound === 'true') return;
    var video = cover.querySelector('video');
    var card = cover.closest('.product-card');
    if (!video || !card) return;

    cover.dataset.videoBound = 'true';

    card.addEventListener('mouseenter', function() {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    });

    card.addEventListener('mouseleave', function() {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (err) {}
    });
  }

  var covers = scope.querySelectorAll('.product-card__cover--video');
  if (!covers.length) return;

  if ('IntersectionObserver' in window) {
    var videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bindVideoCard(entry.target);
          videoObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.01 });

    covers.forEach(function(cover) {
      if (cover.dataset.videoBound === 'true') return;
      videoObserver.observe(cover);
    });
  } else {
    covers.forEach(bindVideoCard);
  }
}

// === 404 path-based copy (address bar still shows original URL) ===
function init404Page() {
  var root = document.querySelector('[data-404-page]');
  if (!root) return;

  var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
  var homeUrl = root.getAttribute('data-home-url') || '/';
  var shopUrl = root.getAttribute('data-shop-url') || '/collections/all';
  var journalUrl = root.getAttribute('data-journal-url') || homeUrl;

  var messages = {
    product: {
      eyebrow: 'Product unavailable',
      title: 'This plant is unavailable',
      desc: 'This plant is no longer available. It may have sold out or been removed from our collection.',
      primary: { label: 'Browse Plants', href: shopUrl },
      secondary: { label: 'Back to Home', href: homeUrl }
    },
    article: {
      eyebrow: 'Article not found',
      title: 'This article could not be found',
      desc: 'This journal entry may have been moved or removed. Explore more plant care stories in our journal.',
      primary: { label: 'Read Journal', href: journalUrl },
      secondary: { label: 'Back to Home', href: homeUrl }
    },
    blog: {
      eyebrow: 'Journal not found',
      title: 'This journal could not be found',
      desc: 'We couldn\u2019t find this journal. Browse our latest plant care stories and updates instead.',
      primary: { label: 'Read Journal', href: journalUrl },
      secondary: { label: 'Back to Home', href: homeUrl }
    },
    collection: {
      eyebrow: 'Collection not found',
      title: 'This collection could not be found',
      desc: 'This collection may have been renamed or removed. Browse our current plant collections instead.',
      primary: { label: 'Browse Plants', href: shopUrl },
      secondary: { label: 'Back to Home', href: homeUrl }
    },
    page: {
      eyebrow: 'Error',
      title: 'Page not found',
      desc: 'The page you were looking for may have moved, been renamed, or never existed.',
      primary: { label: 'Back to Home', href: homeUrl },
      secondary: { label: 'Back to Shop', href: shopUrl }
    },
    default: {
      eyebrow: 'Error',
      title: 'Page not found',
      desc: 'The page you were looking for may have moved, been renamed, or never existed.',
      primary: { label: 'Back to Home', href: homeUrl },
      secondary: { label: 'Back to Shop', href: shopUrl }
    }
  };

  var kind = 'default';
  if (/\/products(\/|$)/.test(path)) {
    kind = 'product';
  } else if (/\/blogs\/[^/]+\/[^/]+/.test(path)) {
    kind = 'article';
  } else if (/\/blogs(\/|$)/.test(path)) {
    kind = 'blog';
  } else if (/\/collections(\/|$)/.test(path)) {
    kind = 'collection';
  } else if (/\/pages(\/|$)/.test(path)) {
    kind = 'page';
  }

  var copy = messages[kind];
  var eyebrow = root.querySelector('[data-404-eyebrow]');
  var title = root.querySelector('[data-404-title]');
  var desc = root.querySelector('[data-404-desc]');
  var primary = root.querySelector('[data-404-primary]');
  var secondary = root.querySelector('[data-404-secondary]');
  var icons = root.querySelectorAll('[data-404-icon]');

  if (eyebrow) eyebrow.textContent = copy.eyebrow;
  if (title) title.textContent = copy.title;
  if (desc) desc.textContent = copy.desc;
  if (primary) {
    primary.textContent = copy.primary.label;
    primary.setAttribute('href', copy.primary.href);
  }
  if (secondary) {
    secondary.textContent = copy.secondary.label;
    secondary.setAttribute('href', copy.secondary.href);
  }

  icons.forEach(function(icon) {
    var match = icon.getAttribute('data-404-icon') === kind;
    icon.classList.toggle('is-active', match);
    if (match) {
      icon.removeAttribute('hidden');
    } else {
      icon.setAttribute('hidden', '');
    }
  });

  root.setAttribute('data-404-kind', kind);
}

// === Newsletter form interception ===
(function() {
  var form = document.querySelector('.subscribe__form form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var email = form.querySelector('input[type="email"]');
    if (!email || !email.value) return;
    var btn = form.querySelector('button[type="submit"]');
    var origText = btn.textContent;
    btn.textContent = 'Subscribing…';
    btn.disabled = true;
    fetch('/contact', { method: 'POST', body: new FormData(form) })
      .then(function() {
        var formWrap = document.getElementById('subscribeForm');
        var success = document.getElementById('subscribeSuccess');
        if (formWrap) formWrap.classList.add('is-success');
        if (success) success.style.display = '';
      })
      .catch(function() {
        btn.textContent = origText;
        btn.disabled = false;
      });
  });
})();
